import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import { RawDateInput, type RawDateInputProps } from './RawDateInput'

export type DateInputProps = RawDateInputProps & InputProps

export const DateInput = ({ wrapperProps, ...fieldProps }: DateInputProps) => {
  const { internalWrapperProps, id } = createInternalWrapperPropsAndId({
    wrapperProps,
    id: fieldProps.id,
  })

  return (
    <InputWrapper {...internalWrapperProps}>
      <RawDateInput {...fieldProps} id={id} />
    </InputWrapper>
  )
}
